import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AUTH_ROUTES } from "@/shared/constants/paths";

// Auth Pages
import { LoginPage } from "@/pages/onboarding/auth/LoginPage";
import ForgotPasswordPage from "@/pages/auth/forgot-password/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/auth/reset-password/ResetPasswordPage";
import LogoutPage from "@/pages/auth/logout/LogoutPage";
import WelcomeBackPage from "@/pages/auth/welcome-back/WelcomeBackPage";

export const authRoutes = (
  <>
    <Route
      path={AUTH_ROUTES.SIGN_IN}
      element={
        <>
          <Helmet>
            <title>Log in - Elayne</title>
          </Helmet>
          <LoginPage />
        </>
      }
    />
    <Route
      path={AUTH_ROUTES.FORGOT_PASSWORD}
      element={
        <>
          <Helmet>
            <title>Forgot password - Elayne</title>
          </Helmet>
          <ForgotPasswordPage />
        </>
      }
    />
    <Route
      path={AUTH_ROUTES.RESET_PASSWORD}
      element={
        <>
          <Helmet>
            <title>Reset password - Elayne</title>
          </Helmet>
          <ResetPasswordPage />
        </>
      }
    />
    <Route
      path={AUTH_ROUTES.LOGOUT}
      element={
        <>
          <Helmet>
            <title>Logging out - Elayne</title>
          </Helmet>
          <LogoutPage />
        </>
      }
    />
    <Route
      path={AUTH_ROUTES.WELCOME_BACK}
      element={
        <>
          <Helmet>
            <title>Welcome back - Elayne</title>
          </Helmet>
          <WelcomeBackPage />
        </>
      }
    />
  </>
);
